import { render, staticRenderFns } from "./WidgetSkilledWorkerVisa.vue?vue&type=template&id=12a946d9&scoped=true&lang=pug"
import script from "./WidgetSkilledWorkerVisa.vue?vue&type=script&lang=ts"
export * from "./WidgetSkilledWorkerVisa.vue?vue&type=script&lang=ts"
import style0 from "./WidgetSkilledWorkerVisa.vue?vue&type=style&index=0&id=12a946d9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a946d9",
  null
  
)

/* custom blocks */
import block0 from "./WidgetSkilledWorkerVisa.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fmodules%2FServices%2FComponents%2FWidgets%2FWidgetSkilledWorkerVisa.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports